import { API_ENDPOINTS } from "@repo/constants";
import {
  ChannelInsert,
  ChannelInsertResponse,
  ChannelList,
  ChannelListResponse,
  ChannelUpdate,
  ChannelUpdateResponse,
} from "@repo/types";
import { channelApiClient } from "../apiClient";
import { AxiosError } from "axios";

export const channelManagerInsert = async (
  payload: Partial<ChannelInsert>,
): Promise<ChannelInsertResponse> => {
  try {
    const response = await channelApiClient.post<ChannelInsertResponse>(
      API_ENDPOINTS.AddChannelManager,
      payload,
    );
    return response.data;
  } catch (err) {
    const error = err as AxiosError<any>;
    console.error("Error creating channel manager:", error);
    const apiMessage =
      error.response?.data?.Message ||
      error.message ||
      "An unexpected error occurred";
    return { Success: false, Message: apiMessage, StatusCode: 500 };
  }
};

export const channelManagerUpdate = async (
  payload: Partial<ChannelUpdate>,
): Promise<ChannelUpdateResponse> => {
  try {
    const response = await channelApiClient.put<ChannelUpdateResponse>(
      API_ENDPOINTS.UpdateChannelManager,
      payload,
    );
    return response.data;
  } catch (err) {
    const error = err as AxiosError<any>;
    console.error("Error updating channel manager:", error);
    const apiMessage =
      error.response?.data?.Message ||
      error.message ||
      "An unexpected error occurred";
    return { Success: false, Message: apiMessage, StatusCode: 500 };
  }
};

export const channelManagerList = async (
  payload: Partial<ChannelList>,
): Promise<ChannelListResponse> => {
  try {
    const response = await channelApiClient.post<ChannelListResponse>(
      API_ENDPOINTS.channelList,
      payload,
    );
    return response.data;
  } catch (err) {
    const error = err as AxiosError<any>;
    console.error("Error fetching channel manager list:", error);
    const apiMessage =
      error.response?.data?.Message ||
      error.message ||
      "An unexpected error occurred";
    return {
      Success: false,
      Message: apiMessage,
      StatusCode: 500,
      Data: [],
    };
  }
};
